<template>
  <div class="goods-order main-bg">
    <div class="main-wrap">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="crumb">
        <el-breadcrumb-item :to="{ path: '/' }">买兰花</el-breadcrumb-item>
        <el-breadcrumb-item>选择分类</el-breadcrumb-item>
        <el-breadcrumb-item>商品详情</el-breadcrumb-item>
        <el-breadcrumb-item>确认订单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="white-bg">
      <div class="main-wrap">
        <h3 class="title-name">选择收货地址</h3>
        <address-item :isCheckedAddress="true" @changCurrentAddress="getCurrentAddressInfo"></address-item>
        <h3 class="title-name">确认订单信息</h3>
        <ul class="tab-head">
          <li>商品名称</li>
          <li>数量</li>
          <li>单价</li>
          <li>运费</li>
          <li>小计</li>
        </ul>
        <ul class="tab-body">
          <li>
            <el-image class="order-img" :src="$common.imgPath(goodsInfo.goodsLog)" :alt="goodsInfo.goodsName" lazy></el-image>
            <span class="order-title">{{goodsInfo.goodsName}}</span>
          </li>
          <li class="txt-16">{{goodsNum}}</li>
          <li class="txt-16">¥{{goodsInfo.price}}</li>
          <li>{{goodsInfo.distributionFee==-1?'邮费到付':goodsInfo.distributionFee==0?'包邮':'¥'+goodsInfo.distributionFee}}</li>
          <li v-text="'¥'+((goodsNum*goodsInfo.price)+goodsInfo.distributionFee)">¥{{payTotalMoney}}</li>
        </ul>
        <div class="count-list">
          <p>
            <span>应付金额：</span>
            <span>¥ <span class="total-money">{{payTotalMoney}}</span></span>
          </p>
          <p>
            <span>收货地址：</span>
            <span v-if="currentAddressInfo">{{currentAddressInfo.name}} {{currentAddressInfo.phone}} {{currentAddressInfo.provinceName}} {{currentAddressInfo.cityName}} {{currentAddressInfo.areaName}} {{currentAddressInfo.address}} </span>
          </p>
          <button type="button" class="btn-base btn-big btn-main btn-small btn-submit" @click="createOrderSubmit()">提交订单</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import addressItem from '../../../components/address/addressItem.vue'
    import {findGoodsInfoById} from '../../../api/goods'
    import {createOrder} from '../../../api/order'
    /*import {getAddressIp} from '../../../api/addressIp'*/
  export default {
      data(){
          return {
              userInfo:JSON.parse(localStorage.getItem('user'))||null,//登录用户信息
              currentAddressInfo:'',//获取当前地址信息
              totalMoney:0,//资金余额
              current:1,
              size:20,
              goodsInfo:'',
              shopInfo:'',
              orderInfo:'',//创建订单成功是返回的订单信息
              payTotalMoney:0,//应支付金额
          }
      },
      components:{
          addressItem
      },
      computed:{
          goodsId(){
              return this.$route.params.goodsId;
          },
          goodsNum(){
              return parseInt(this.$route.params.goodsNum);
          }
      },
      created () {
          this.getMeUserInfo();
          this.getGoodsInfo();

      },
      mounted(){
          /*this.getAddressIpInfo();*/
      },
      methods:{
          /*getAddressIpInfo(){
              getAddressIp().then((res)=>{
                  let cip = res.returnCitySN["cip"];
                  /!*this.addressIp=JSON.parse(res).returnCitySN.cip;*!/
                  console.log('12122',res);
                  console.log('12122',cip);
              }).catch(err=>err);
          },*/
          getMeUserInfo(){
              this.$store.dispatch('getMeInfoData',this.userInfo).then(res=>{
                  this.userInfo=res.data.user;
                  this.totalMoney=res.data.user.account;
              }).catch(err=>err)
          },
          getGoodsInfo(){
              findGoodsInfoById({
                  userId:this.userInfo.userId,
                  goodsId:this.goodsId,
                  current:this.current,
                  size:this.size
              }).then(res=>{
                  this.goodsInfo=res.data.goods;
                  this.shopInfo=res.data.shop;
                  this.payTotalMoney=(this.goodsNum*this.goodsInfo.price)+this.goodsInfo.distributionFee;
              }).catch(err=>err)
          },
          getCurrentAddressInfo(current){
              this.currentAddressInfo=current;
          },
          createOrderSubmit(){
              createOrder({
                  userId:this.userInfo.userId,
                  addressId:this.currentAddressInfo.id,
                  goodsId:this.goodsId,
                  shopId:this.shopInfo.shopId,
                  goodsNum:this.goodsNum
              }).then((res)=>{
                  this.orderInfo=res.data.order;
                  this.$router.push({'path':'/goods/order/pay/'+this.orderInfo.id});
              }).catch(err=>err)
          }
      }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/common";
  .crumb{
    padding:15px 0;
  }
  .goods-order{
    .title-name{font-size:16px;
      font-weight:600;color:#333;padding:30px 0 20px;}
    .pay-type{
      overflow: hidden;
      &>li{
        cursor: pointer;
        position: relative;
        float: left;
        text-align: center;
        width:220px;
        height:38px;
        line-height:38px;
        border:1px solid $main-color;
        color:#333;
        font-size:15px;
        &+li{margin-left:25px;}
        .icon-gou{
          display: none;
          position: absolute;
          right:0;
          bottom:-1px;
          border-style: solid;
          border-width: 0px 0px 22px 22px;
          border-color: transparent transparent $main-color transparent;
          width: 0px;
          height: 0px;
          .el-icon-check{
            position: absolute;
            bottom: -22px;
            right: 3px;
            font-size: 7px;
            color: #fff;
          }
        }
        &.selected{
          border:1px solid $main-color;
          .icon-gou{display: block;}
        }
      }
    }
    .tab-head{
      display: table;
      width:100%;
      height:40px;
      background-color:#F5F5F5;
      font-size:14px;
      color:#333;
      li{
        display: table-cell;
        vertical-align: middle;
        text-align: left;
        width:124px;
        &:first-child{
          width:400px;
          padding-left:20px;
        }

      }
    }
    .tab-body{
      display: table;
      width:100%;
      border-bottom:1px solid #E0E0E0;
      li{
        display: table-cell;
        vertical-align: top;
        text-align: left;
        width:124px;
        padding:20px 0;
        .btn-item{background-color:#F5F5F5;border-color:#D9D9D9;}
        .btn-item+.btn-item{
          display: block;
          margin-top:10px;
        }
        &:first-child{
          width:400px;
          text-align: left;
          padding-left:20px;
        }
      }
      .order-img{
        display: inline-block;
        width:100px;
        height:100px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background-color:$main-color;
      }
      .order-title{
        display: inline-block;
        font-size:16px;
        padding-left:10px;
        width:208px;
        vertical-align: top;
        padding-top:8px;
      }
    }
    .count-list{
      padding:20px 0 50px;
      font-size:14px;
      float: right;
      text-align: right;
      p{
        height:32px;
        line-height:32px;
        overflow: hidden;
        &>span:first-child{
          float: left;color:#999;}
        &>span:last-child{
          float: left;color:#333;}
        .total-money{font-size:18px;color:#FF2D2D}
        &:nth-child(1),&:nth-child(3){
          &>span:first-child{
            float: none;}
          &>span:last-child{
            display: inline-block;
            float: none;width:150px;}
        }
      }
      .btn-submit{margin-top:10px;}
    }
  }

</style>
<style lang="scss">
  @import "../../../assets/css/common";

</style>

